<template>
  <div>
    <!-- <AddModule
      :isPopupActive="modulePopupActive"
      @closePopup="toggleModulePopup"
      :data="moduleData"
    /> -->
    <AddLessons
      @closePopup="toggleLessonsPopup"
      :courseData="courseData"
      :lessonData="lessonData"
      :isPopupActive="lessonPopupActive"
      :existingModule="existingModule"
      :existingVideo="existingVideo"
    />

    <!-- video in player -->
    <vs-popup
      class="holamundo"
      title="Add/Update Lesson"
      :active.sync="isVideoPopup"
    >
      <!-- <v-card class="text-center"> -->
        
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <video-player v-if="previewUrl" :key="previewUrl" :options="videoOptions" />
          </div>
        </div>
      <!-- </v-card> -->

      <!-- <div>
        <video
          ref="curVideo"
          :src="videoUrl"
          loading="lazy"
          width="720"
          height="480"
          style="border: none"
          allowfullscreen="true"
          controls
        ></video>
      </div> -->

    </vs-popup>

    <!-- another method -->

    <vs-card v-if="!showLessons">
      <!-- <label class="display-5 mt-5"> Course Name</label> -->
      <div class="flex justify-between align-items-center mb-3">
        <div><h1>Manage Course</h1></div>
        <vs-button @click="goToCourseList">Back</vs-button>
      </div>
      <div class="flex justify-between align-items-center mb-3">
        <vs-button class="mt-3" @click="addLesson">Add Lessons</vs-button>
      </div>
      <vs-table pagination max-items="10" search stripe :data="modules">
        <template slot="thead">
          <vs-th sort-key="moduleName">Module name</vs-th>
          <vs-th sort-key="parentCategory">Lessons</vs-th>
          <!-- <vs-th sort-key="">Actions</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <tbody
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            @click="manageModule(tr)"
          >
            <vs-tr>
              <vs-td :data="data[indextr]._id.module">
                {{ data[indextr]._id.module }}
              </vs-td>

              <vs-td :data="data[indextr].lessonList.length">
                {{ data[indextr].lessonList.length }}
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vs-card>
    <vs-card v-if="showLessons">
      <div class="flex justify-between align-items-center mb-3">
        <div><h1>Manage Course</h1></div>
        <vs-button @click="showLessons = false">Back</vs-button>
      </div>
      <!-- <vs-button class="mt-3" @click="addLesson">Add Lessons</vs-button
      ><br /><br /> -->
      <vs-table pagination max-items="10" stripe :data="lessons" v-if="lessons">
        <template slot="thead">
          <vs-th sort-key="title">Title</vs-th>
          <vs-th sort-key="description">Description</vs-th>
          <vs-th sort-key="description">Start Time</vs-th>
          <vs-th sort-key="isEnabled">Access</vs-th>
          <vs-th sort-key="video rul">Status</vs-th>
          <vs-th sort-key="date">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].title">
              {{ data[indextr].title }}
            </vs-td>

            <vs-td :data="data[indextr].description">
              {{ data[indextr].description }}
            </vs-td>

            <vs-td :data="data[indextr].startTime">
              {{ data[indextr].startTime }}
            </vs-td>

            <vs-td :data="data[indextr].isEnabled">
              {{ data[indextr].isEnabled? "Enabled": "Disabled" }}
            </vs-td>

            <!-- <vs-td v-if="tr.videoUrl" :data="data[indextr].videoUrl">
              {{ data[indextr].videoUrl.substr(34, 13) }}
            </vs-td> -->

            <vs-td :data="data[indextr].videoUrl">
              <!-- {{ data[indextr].videoUrl.substr(29, 13) }} -->
              <span v-if="data[indextr].retryCount > 3">Failed</span>
              <span v-else-if="data[indextr].isProcessed">Processed</span>
              <span v-else>In Progress ({{ data[indextr].progress }} %) </span>
            </vs-td>

            <vs-td v-if="data[indextr].isProcessed" class="whitespace-no-wrap">
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="playVideo(tr)"
              />
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                class="ml-2"
                @click.stop="editLesson(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteLesson(tr)"
              />
            </vs-td>
            <vs-td v-if="data[indextr].retryCount > 3">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                class="ml-2"
                @click.stop="editLesson(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteLesson(tr)"
              />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
/* eslint-disable */
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import AddModule from '@/views/pages/courses/addModule.vue'
import AddLessons from '@/views/pages/courses/addLessons.vue'
import moduleDataList from '@/store/courses/moduleDataList.js'
import moduleVideoLibrary from '@/store/videoLibrary/moduleVideoLibrary.js'
import VideoPlayer from '@/views/components/VideoPlayer.vue'

export default {
  // props: {
  //   isSidebarActive: {
  //     type: Boolean,
  //     required: true
  //   },
  //   data: {
  //     type: Array
  //     // default: () => {}
  //   }
  // },
  components: {
    VuePerfectScrollbar,
    AddModule,
    AddLessons,
    VideoPlayer
  },
  data() {
    return {
      videoTitle: 'title of video playing',
      videoUrl: '',
      dialogVideo: false,
      dataId: null,
      dataTitle: '',
      dataCategory: null,
      dataImg: null,
      dataVid: null,
      dataStatus: 'live',
      dataPrice: 0,
      modulePopupActive: false,
      lessonPopupActive: false,
      showLessons: false,
      lesssonsInfo: null,
      courseData: null,
      moduleData: {},
      lessonData: {},

      previewUrl: null,
      videoOptions: {
        controls: true,
        sources: [
          {
            src: '',
            type: 'application/x-mpegURL'
          }
        ]
      },

      modules1: [
        {
          name: 'Module1',
          description: 'module1 desc',
          lessons: ['videoUrl1', 'videoUrl2'],
          duration: 7
        },
        {
          name: 'Module1',
          description: 'module1 desc',
          lessons: ['videoUrl1', 'videoUrl2'],
          duration: 7
        }
      ],

      category_choices: [
        { text: 'Robotics', value: 'robotics' },
        { text: 'Computers', value: 'computers' }
      ],

      status_choices: [
        { text: 'Live', value: 'live' },
        { text: 'Not Live', value: 'not-live' }
      ],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  watch: {
    // isSidebarActive(val) {
    //   if (!val) return
    //   if (Object.entries(this.data).length === 0) {
    //     this.initValues()
    //     this.$validator.reset()
    //   } else {
    //     const { category, id, img, vid, title, status, price } = JSON.parse(
    //       JSON.stringify(this.data)
    //     )
    //     this.dataId = id
    //     this.dataCategory = category
    //     this.dataImg = img
    //     this.dataVid = vid
    //     this.dataTitle = title
    //     this.dataStatus = status
    //     this.dataPrice = price
    //     this.initValues()
    //   }
    //   // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    // }
  },
  computed: {
    // isSidebarActiveLocal: {
    //   get() {
    //     return this.isSidebarActive
    //   },
    //   set(val) {
    //     if (!val) {
    //       this.$emit('closeSidebar')
    //       // this.$validator.reset()
    //       // this.initValues()
    //     }
    //   }
    // },
    isVideoPopup: {
      get() {
        return this.dialogVideo
      },
      set(val) {
        // console.log('isViseopopup set', val)
        if (!val) {
          console.log(' inside isVideoPopup set', val)
          this.dialogVideo = false
          this.previewUrl = null
          // this.videoOptions = {}
          this.videoOptions.sources[0].src = ''          
        }
      }
    },
    modules() {
      return this.$store.state.courses.modules
    },
    lessons() {
      return this.$store.state.courses.lessons
    },
    videoList() {
      return this.$store.state.videoLibrary.videoLibrary
    },
    existingModule() {
      const existingModules = []
      if (this.modules) {
        this.modules.forEach((m) => {
          existingModules.push({ text: m._id.module, value: m._id.module })
        })
      }
      return existingModules
    },
    existingVideo() {
      // console.log('videoList',this.videoList )
      const existingVideos = []
      if (this.videoList) {
        this.videoList.forEach((m) => {
          existingVideos.push({ label: m.videoName, value:{videoUrl: m.videoUrl , path:m.path , videoName: m.videoName, videoDescription:m.videoDescription}})
        })
      }
      return existingVideos
    },
    isFormValid() {
      return (
        !this.errors.any() &&
        this.dataTitle &&
        this.dataCategory &&
        this.dataPrice > 0
      )
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    goToCourseList() {
      this.$router.push('/pages/courses/coursesList')
    },
    playVideo(video) {
      if (video) {
        // this.videoUrl = video.videoUrl
        // this.videoTitle = video.title
        this.previewUrl = video.videoUrl
        this.videoOptions.sources[0].src = video.videoUrl
        this.dialogVideo = true
      } else {
        this.$showWarningToast(this, 'Preview not available')
      }
    },
    closeVideo() {
      this.videoUrl = ''
      this.videoTitle = ''
      this.dialogVideo = false
    },

    manageModule(moduleData) {
      // console.log('module from table line384', moduleData._id.module)
      this.showLessons = true
      this.$store
        .dispatch('courses/fetchLessons', moduleData._id)
        .catch((err) => {
          console.error(err)
        })
      // const stateModules= this.$store.state.courses.modules
      // stateModules.forEach(m => {
      //   console.log('module from state line388', m)
      //   if(m._id.module === moduleData._id.module) {
      //     this.lesssonsInfo = m.lessonList
      //   }
      // })
    },

    addLesson() {
      this.courseData = this.$route.params.courseId
      this.lessonData = {}
      this.toggleLessonsPopup(true)
    },
    editLesson(data) {
      this.lessonData = data
      this.toggleLessonsPopup(true)
    },
    deleteLesson(data) {
      // console.log("delete data", data)
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirm Delete',
        text: `You are about to delete "${data.title}"`,
        accept: () => {
          this.showDeleteSuccess(data)
        },
        acceptText: 'Delete'
      })
    },
    showDeleteSuccess(data) {
      this.$store
        .dispatch('courses/removeLesson', data)
        .then((response) => {
          this.$vs.notify({
            color: 'success',
            title: 'Deleted',
            text: response.data.data
          })
        })
        .catch((err) => {
          console.error(err)
        })
    },
    deleteModule(data) {
      this.$store.dispatch('courses/removeModule', data).catch((err) => {
        console.error(err)
      })
    },
    toggleModulePopup(val = false) {
      this.modulePopupActive = val
    },
    toggleLessonsPopup(val = false) {
      this.lessonPopupActive = val
    },
    initValues() {
      if (this.data.id) return
      this.dataId = null
      this.dataTitle = ''
      this.dataCategory = null
      this.dataStatus = 'live'
      this.dataPrice = 0
      this.dataImg = null
      this.dataVid = null
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const obj = {
            id: this.dataId,
            title: this.dataTitle,
            img: this.dataImg,
            vid: this.dataVid,
            category: this.dataCategory,
            status: this.dataStatus,
            price: this.dataPrice
          }

          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('dataList/updateItem', obj).catch((err) => {
              console.error(err)
            })
          } else {
            delete obj.id
            obj.popularity = 0
            this.$store.dispatch('dataList/addItem', obj).catch((err) => {
              console.error(err)
            })
          }

          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    updateCurrVid(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.dataVid = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
  },
  created() {
    if (!moduleDataList.isRegistered) {
      this.$store.registerModule('courses', moduleDataList)
      moduleDataList.isRegistered = true
    }
    // console.log('data id to created', this.$route.params.courseId)
    this.$store.dispatch('courses/fetchModules', this.$route.params.courseId)
    if (!moduleVideoLibrary.isRegistered) {
      this.$store.registerModule('videoLibrary', moduleVideoLibrary)
      moduleVideoLibrary.isRegistered = true
    }
    this.$store.dispatch('videoLibrary/fetchVideoLibrary')    
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
